<div class="details-section new-container">
  <div class="loader-while" *ngIf="!kryptomon">
    <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
  </div>
  <div class="details-card" *ngIf="kryptomon!==undefined">
    <div class="details-card-header">
      <div class="name-details-block">
        <div class="name-block" (click)="showNameField()"
          *ngIf="!showTextInput && !kryptomon.rental && !kryptomon.isRentedOut && !kryptomon.isStarter && isUserOf">
          <h1 *ngIf="kryptomon.name!==undefined && kryptomon.name!=='' && kryptomon.name!==null">
            <fa-icon [icon]="['fas', 'pen']"></fa-icon>{{kryptomon.name}}
          </h1>
          <h1 *ngIf="kryptomon.name==undefined || kryptomon.name=='' || kryptomon.name==null">#{{kryptomon.tokenId}}
          </h1>
        </div>
        <div class="name-block rented"
          *ngIf="kryptomon.rental || kryptomon.isRentedOut || kryptomon.isStarter || !isUserOf">
          <h1 *ngIf="kryptomon.name!==undefined && kryptomon.name!=='' && kryptomon.name!==null">{{kryptomon.name}}</h1>
          <h1 *ngIf="kryptomon.name==undefined || kryptomon.name=='' || kryptomon.name==null">#{{kryptomon.tokenId}}
          </h1>
        </div>
        <div class="name-input" [ngClass]="{'hide':!showTextInput}">
          <input id="kryptomonName" type="text" [(ngModel)]="kryptomonName" (blur)="showTextInput = !showTextInput"
            (keydown.enter)="saveName()" />
        </div>
        <div class="small-details">
          <div class="item-block">
            <div class="Stars" style="--rating: {{kryptomon.tierNumber}}"></div>
            <span>{{kryptomon.tierName}}</span>
          </div>
          <div class="item-block" *ngIf="kryptomon.extraData.unfreezable==1">
            <img src="./assets/img/Icon/aura.svg" />
            <span>Aura</span>
          </div>
          <div class="item-block" *ngIf="kryptomon.order">
            <div class="item-block-small">
              <span class="dollar-span">$</span>
              <span>{{kryptomon.order.priceUSD.toLocaleString()}}</span>
            </div>
            <div class="item-block-divider"></div>
            <div class="item-block-small">
              <img src="./assets/img/Icon/Cur-BNB.png"
                *ngIf="kryptomon.order.paymentToken=='0x0000000000000000000000000000000000000000'">
              <img src="./assets/img/Icon/Cur-Kmon.png"
                *ngIf="kryptomon.order.paymentToken!=='0x0000000000000000000000000000000000000000'">
              <span>{{kryptomon.order.tokenPaymentAmount.toLocaleString()}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="actions-block"
        *ngIf="!kryptomon.rental && !kryptomon.isRentedOut && !kryptomon.isStarter && isUserOf">
        <div class="button-outline button-outline-icon" *ngIf="kryptomon.status==2" (click)="openBreed()">
          <img src="./assets/img/Icon/breeding-color.svg">Breed
        </div>
        <div class="button-outline button-outline-icon"
          *ngIf="kryptomon.isReadyToEvolve && hasAllowance && !loadingAllowance && !kryptomon.isEvolving"
          (click)="startEvolving()">
          <img src="./assets/img/Icon/evolve.svg">Evolve
        </div>
        <div class="button-grey timer-hatching" *ngIf="!kryptomon.isReadyToHatch && kryptomon.status==0">
          <img src="./assets/img/Icon/hatch.svg">
          <countdown units="Hours | Minutes | Seconds" [divider]="divider" [text]="text"
            end="{{ kryptomon.hatchingDateFormatted }}"></countdown>
        </div>
        <div class="button-outline button-outline-icon"
          *ngIf="kryptomon.isReadyToHatch && hasAllowance && !loadingAllowance && !kryptomon.hatching && kryptomon.tokenId!==6188"
          (click)="startHatching()">
          <img src="./assets/img/Icon/hatch.svg">Hatch
        </div>
        <div class="button-outline"
          *ngIf="(kryptomon.isReadyToHatch || kryptomon.isReadyToEvolve) && !hasAllowance && !loadingAllowance"
          (click)="grantAllowance()">
          Grant Allowance
        </div>
        <div class="button-outline" *ngIf="loadingAllowance || kryptomon.hatching || kryptomon.isEvolving">
          <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
        </div>
        <div class="button-gradient" (click)="showSaleModal=true" *ngIf="!kryptomon.order && !isLoading && !isSuccess">
          Sell
        </div>
        <div class="button-gradient" (click)="removeSale()" *ngIf="kryptomon.order && !isLoading && !isSuccess">
          Remove Sale
        </div>
        <div class="button-gradient" *ngIf="!isLoading && isSuccess">
          <fa-icon [icon]="['fas', 'check']"></fa-icon>
        </div>
        <div class="button-gradient" *ngIf="isLoading && !isSuccess">
          <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
        </div>
        <div class="button-grey" (click)="showTransferModal=true">
          Transfer
        </div>
        <!--<div class="notification-round">
          <img src="./assets/img/Icon/Notification.png">
        </div>-->
      </div>
      <div class="actions-block" *ngIf="kryptomon.isStarter && isUserOf">
        <div class="button-outline button-outline-icon" *ngIf="kryptomon.isReadyToEvolve && !kryptomon.isEvolving"
          (click)="evolveFree2Play()">
          <img src="./assets/img/Icon/evolve.svg">Evolve
        </div>
        <div class="button-grey timer-hatching" *ngIf="!kryptomon.isReadyToHatch && kryptomon.status==0">
          <img src="./assets/img/Icon/hatch.svg">
          <countdown units="Hours | Minutes | Seconds" [divider]="divider" [text]="text"
            end="{{ kryptomon.hatchingDateFormatted }}"></countdown>
        </div>
        <div class="button-outline button-outline-icon" *ngIf="kryptomon.isReadyToHatch && !kryptomon.hatching"
          (click)="hatchFree2Play()">
          <img src="./assets/img/Icon/hatch.svg">Hatch
        </div>
        <div class="button-grey" (click)="migrateKryptomon()" *ngIf="kryptomon.trainedLevel>0">
          <img src="./assets/img/Icon/trained-level-icon.png">Migrate Levels
        </div>
        <div class="button-outline" *ngIf="kryptomon.hatching || kryptomon.isEvolving || kryptomon.isDestroying">
          <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
        </div>
      </div>
      <div class="actions-block" *ngIf="kryptomon.rental && !kryptomon.isRentedOut">
        <div class="button-grey" (click)="openPlaydex(kryptomon.tokenId)">
          <img src="./assets/img/Icon/playdex.png"> Rented Since: {{kryptomon.startingDate}}
        </div>
      </div>
      <div class="actions-block" *ngIf="kryptomon.isRentedOut">
        <div class="button-grey" (click)="openPlaydex(kryptomon.tokenId)">
          <img src="./assets/img/Icon/playdex.png"> Manage Renting
        </div>
      </div>
      <div class="actions-block" *ngIf="!isUserOf && !kryptomon.isRentedOut">
        <div class="button-gradient" *ngIf="kryptomon.order" (click)="showBuyModal = !showBuyModal">
          Buy
        </div>
        <div class="button-outline" (click)="showBidModal = !showBidModal">
          Bid
        </div>
      </div>
    </div>
    <div class="details-card-kryptomon"
      [ngClass]="{'ghost': selectedElement=='ghost', 'fire': selectedElement=='fire', 'electro': selectedElement=='electro', 'ice': selectedElement=='ice', 'water': selectedElement=='water', 'grass': selectedElement=='grass', 'ground': selectedElement=='ground', 'air': selectedElement=='air'}">
      <div class="navigation left" (click)="loadPreviousTop()" *ngIf="navigatingIndex>0 && isUserOf">
        <fa-icon [icon]="['fas', 'chevron-left']"></fa-icon>
      </div>
      <div class="navigation right" (click)="loadNextTop()"
        *ngIf="navigatingIndex<kryptomonsV2Navigation.length-1 && isUserOf">
        <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
      </div>
      <div class="image-column">
        <img src="{{kryptomon.image}}" />
      </div>
      <div class="infos-column">
        <div class="info-top-row">
          <div class="item-block item-block-gameStatus">
            <div class="item-block-small">
              <img src="{{kryptomon.gameStatusImage}}">{{kryptomon.gameStatus}}
            </div>
            <div class="item-block-divider">
            </div>
            <div class="item-block-small">
              <img src="./assets/img/Icon/trained-level-icon.png">TRAINED LEVEL {{kryptomon.trainedLevel}}/50
            </div>
          </div>
          <div class="item-block">
            <div class="item-block-small breeding-color">
              <img src="./assets/img/Icon/breeding-color.png">
              <span *ngIf="kryptomon.status>1">{{kryptomon.breedingDone}}/{{kryptomon.breedingTotal}}</span>
              <span *ngIf="kryptomon.status<2">N/A</span>
            </div>
          </div>
          <div class="item-block gender-icon">
            <img src="{{kryptomon.genderIcon}}" />
          </div>
          <div class="item-block">
            GEN: {{kryptomon.genes.generation}}
          </div>
          <div class="item-block">
            ID: {{kryptomon.tokenIdFormatted}}
          </div>
        </div>
        <div class="info-bottom-row">
          <div class="info-family-selection">
            <div class="family-card" (click)="selectFamily(kryptomon.elementType, 0)"
              [ngClass]="{'selected':selectedFamilyCard[0], 'ghost': selectedElement=='ghost', 'fire': selectedElement=='fire', 'electro': selectedElement=='electro', 'ice': selectedElement=='ice', 'water': selectedElement=='water', 'grass': selectedElement=='grass', 'ground': selectedElement=='ground', 'air': selectedElement=='air'}">
              <span class="title">MAIN FAMILY</span>
              <div class="family-icon-block">
                <img src="{{kryptomon.mainFamilyImage}}" />
                <span>{{kryptomon.elementType}}</span>
              </div>
              <span class="power-title">Total Power</span>
              <div class="Stars-Full" style="--rating: {{kryptomon.stats[2][1].stars}}"></div>
              <div class="divider"></div>
              <div class="detail-family">
                Genes: <span>{{kryptomon.mainGenes}}/100</span>
              </div>
              <div class="detail-family">
                Talent: <span>{{kryptomon.mainTalent}}/100</span>
              </div>
            </div>
            <div class="family-card" (click)="selectFamily(kryptomon.elementTypeSecond,1)"
              [ngClass]="{'selected':selectedFamilyCard[1], 'ghost': selectedElement=='ghost', 'fire': selectedElement=='fire', 'electro': selectedElement=='electro', 'ice': selectedElement=='ice', 'water': selectedElement=='water', 'grass': selectedElement=='grass', 'ground': selectedElement=='ground', 'air': selectedElement=='air'}">
              <span class="title">SECOND FAMILY</span>
              <div class="family-icon-block">
                <img src="{{kryptomon.secondaryFamilyImage}}" />
                <span>{{kryptomon.elementTypeSecond}}</span>
              </div>
              <span class="power-title">Total Power</span>
              <div class="Stars-Full" style="--rating: {{kryptomon.stats[3][1].stars}}"></div>
              <div class="divider"></div>
              <div class="detail-family">
                Genes: <span>{{kryptomon.secondGenes}}/100</span>
              </div>
              <div class="detail-family">
                Talent: <span>{{kryptomon.secondTalent}}/100</span>
              </div>
            </div>
          </div>
          <div class="info-star-stats">
            <div class="item-block" *ngFor="let stat of kryptomon.stats">
              <span>{{stat[1].name}}</span>
              <div class="Stars-Full" style="--rating: {{stat[1].stars}}"></div>
              <span>{{stat[1].valueScaled}}/100</span>
            </div>
          </div>
        </div>
      </div>
      <div class="spells-icons-block">
        <div class="spell-icon" *ngFor="let spell of spells; let i = index" (click)="selectSpell(i)">
          <img src="./assets/img/spells/{{spell.element}}/{{spell.icon}}.png" />
        </div>
      </div>
    </div>
    <div class="spell-description-box" *ngIf="spellDescription!==undefined">
      <span><b>{{spellName}}:</b> {{spellDescription}}</span>
    </div>
    <div class="details-card-performance" *ngIf="kryptomon.gameMetadata.attackLevel!==undefined">
      <h3>My performance in game</h3>
      <div class="performance-card-container">
        <div class="performance-card">
          <div class="performance-card-title">
            <img src="./assets/img/Icon/trained-level-icon.png" />
            <h5>Trained Levels</h5>
            <span>{{kryptomon.trainedLevel}}/50</span>
          </div>
          <div class="performance-card-items">
            <div class="performance-card-item" *ngFor="let tl of trainingLevels">
              <span>{{tl.name}}</span>
              <div class="progress-bar">
                <span class="progress-bar-fill" [style]="'width: '+tl.percentage+'%;'"></span>
              </div>
              <span class="ratioSpan">{{tl.value}}/50</span>
            </div>
          </div>
        </div>
        <div class="performance-card">
          <div class="performance-card-title">
            <img src="./assets/img/Icon/Caring.svg" />
            <h5>Caring</h5>
          </div>
          <div class="performance-card-items">
            <div class="performance-card-item">
              <span>Status</span>
              <img src="{{kryptomon.gameStatusImage}}">{{kryptomon.gameStatus}}
            </div>
            <div class="performance-card-item" *ngFor="let cl of caringLevels">
              <span>{{cl.name}}</span>
              <div class="progress-bar">
                <span class="progress-bar-fill" [style]="'width: '+ cl.percentage+'%;'"></span>
              </div>
              <span class="ratioSpan">{{cl.value}}/{{cl.maxValue}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="details-card-life">
      <h3>My life so far...</h3>
      <div class="details-card-life-header">
        <div class="item-block item-block-gameStatus">
          <div class="item-block-small">
            <img src="./assets/img/Icon/instinct.svg">AGE
          </div>
          <div class="item-block-divider">
          </div>
          <div class="item-block-small">
            {{kryptomon.age}}
          </div>
        </div>
        <div class="right-actions">
          <div class="action-life" (click)="filterActivity=''">
            <!--<fa-icon [icon]="['fas', 'times']"></fa-icon>-->
            <span>Show all</span>
          </div>
          <div class="action-life" (click)="filterActivity='evolved'" *ngIf="activityExist[0]">
            <img src="./assets/img/Icon/evolve.svg" />
            <span>Evolve</span>
          </div>
          <div class="action-life" (click)="filterActivity='breed'" *ngIf="activityExist[1]">
            <img src="./assets/img/Icon/Breeding.svg" />
            <span>Breeding</span>
          </div>
          <div class="action-life" (click)="filterActivity='transfer'" *ngIf="activityExist[2]">
            <img src="./assets/img/Icon/Transfer.svg" />
            <span>Transfer</span>
          </div>
          <div class="action-life" (click)="filterActivity='sold'" *ngIf="activityExist[3]">
            <img src="./assets/img/Icon/Sold.svg" />
            <span>Sold</span>
          </div>
        </div>
      </div>
      <div class="details-card-life-timeline">
        <div class="details-card-life-timeline-activity {{act.title}}-activity"
          *ngFor="let act of kryptomon.activities | activitiesFilter: filterActivity">
          <div class="activity-image">
            <img src="{{act.img}}" />
          </div>
          <div class="bullet-dot">
          </div>
          <span class="date-activity">{{act.timeFormatted}}</span>
          <span class="title-activity">{{act.title}}</span>
          <div class="details-activity" *ngIf="act.title=='transfer'">
            <span class="pink">{{act.seller}}</span>
            <span>transfer to</span>
            <span class="pink">{{act.buyer}}</span>
          </div>
          <div class="details-activity" *ngIf="act.title=='laid'">
            <span>Mother ID: <span class="pink"> {{act.motherId}}</span></span>
            <span>Father ID: <span class="pink"> {{act.fatherId}}</span></span>
          </div>
          <div class="details-activity" *ngIf="act.title=='breed'">
            <span>Breed with</span>
            <span>Partner: <span class="pink"> {{act.partner}}</span></span>
            <!--<span>Child: </span>-->
          </div>
          <div class="details-activity" *ngIf="act.title=='sold'">
            <span>Seller: <span class="pink">{{act.seller}}</span></span>
            <span>Buyer: <span class="pink">{{act.buyer}} </span></span>
            <span>Price: <span class="pink">{{act.amount}} {{act.currency}}</span></span>
          </div>
        </div>
      </div>
    </div>
    <div class="details-card-skills">
      <h3>Skills and abilities</h3>
      <div class="skills-container">
        <div class="skills-column" *ngFor="let chunk of chunkedSkills">
          <div class="skill-card" *ngFor="let skills of chunk">
            <div class="skill-card-title">
              <h5>{{skills.name}}</h5>
              <p>{{skills.description}}</p>
            </div>
            <div class="skill-card-items">
              <div class="skill-card-item" *ngFor="let skill of skills.skills">
                <img src="{{skill.img}}">
                <span>{{skill.name}}</span>
                <span *ngIf="skills.name!=='Breeding Info'">{{skill.value}}</span>
                <span class="breeding-set cancel"
                  *ngIf="isUserOf && skill.name=='breeding price' && skill.value>0 && skills.name=='Breeding Info' && !isLoading"
                  (click)="removeFromBreedingCenter()">Cancel</span>
                <span
                  *ngIf="skill.name=='breeding price' && skill.value>0 && skills.name=='Breeding Info' && !isLoading">{{skill.value.toLocaleString()}}
                  <img src="./assets/img/Icon/kmon-logo-micro.png"></span>
                <span
                  *ngIf="skill.name=='breeding price' && skill.value>0 && skills.name=='Breeding Info' && isLoading">
                  <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
                </span>
                <span *ngIf="skill.name!=='breeding price' && skills.name=='Breeding Info'">{{skill.value}}</span>
                <span *ngIf="skill.name=='breeding price' && skill.value==0" class="breeding-not-set">Not Set</span>
                <span
                  *ngIf="skill.name=='breeding price' && skill.value==0 && !kryptomon.rental && !kryptomon.isRentedOut && isUserOf"
                  class="breeding-set" (click)="showBreedModal=true">Set price</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="details-card-perks">
    </div>
    <div class="details-card-other">
      <h3 *ngIf="isUserOf">Others</h3>
      <h3 *ngIf="!isUserOf">Your Kryptomons</h3>
      <div class="detail-card-navigation">
        <div class="navigation left" (click)="navigateToLeftOther()">
          <fa-icon [icon]="['fas', 'chevron-left']"></fa-icon>
        </div>
        <div class="navigation right" (click)="loadNewOther()">
          <fa-icon [icon]="['fas', 'chevron-right']"></fa-icon>
        </div>
        <div class="deatail-card-other-block" #scrollableOthers>
          <div class="other-card" *ngFor="let oK of otherKryptomons" id="otherKryptomon"
            (click)="openNewDetails(oK.tokenId)">
            <div class="other-card-img" [ngClass]="{'full-width': oK.status==0}">
              <img src="{{oK.image}}" />
            </div>
            <div class="other-card-content">
              <div class="name-row">
                <span>{{oK.name}}</span>
                <span *ngIf="oK.order" class="price-span">${{oK.order.priceUSD.toLocaleString()}}</span>
              </div>
              <div class="other-card-rating">
                <div class="Stars" style="--rating: {{oK.tierNumber}}"></div>
                {{oK.tierName}}
              </div>
              <span>Speciality: {{oK.speciality}}</span>
              <div class="other-card-icons">
                <div class="other-card-element">
                  <img src="{{oK.mainFamilyImage}}" />
                </div>
                <div class="other-card-element">
                  <img src="{{oK.secondaryFamilyImage}}" />
                </div>
                <div class="other-card-breed" *ngIf="oK.breedingTotal">
                  <img src="./assets/img/Icon/Heart.png" />
                  {{oK.breedingDone}}/{{oK.breedingTotal}}
                </div>
                <div class="other-card-sex">
                  <img src="{{oK.genderIcon}}" />
                </div>
                <div class="other-card-gen">
                  GEN: {{oK.genes.generation}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="transfer-modal-overlay" *ngIf="showTransferModal">
    <div class="transfer-modal">
      <div class="transfer-modal-transfer" *ngIf="!isSuccess">
        <div class="transfer-modal-text">
          <h3>Transfer</h3>
          <p class="text-gray">You are about to send this Kryptomon to another wallet</p>
          <p class="text-gray">Please enter the receiver address below.</p>
        </div>
        <div class="transfer-modal-input">
          <p>Wallet Address</p>
          <input type="text" placeholder="0x00000..." [(ngModel)]="receiverAddress"
            (ngModelChange)="isValidAddressKmon()" />
        </div>
        <div class="transfer-modal-buttons">
          <div class="button-gradient" *ngIf="validAddress && !isLoading" (click)="initiateTransfer()">
            Proceed
          </div>
          <div class="button-gradient disabled" *ngIf="!validAddress">
            Proceed
          </div>
          <div class="button-gradient" *ngIf="isLoading">
            <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
          </div>
          <div class="button-outline" (click)="showTransferModal=false" *ngIf="!isLoading">
            Cancel
          </div>
        </div>
      </div>
      <div class="transfer-modal-success" *ngIf="isSuccess">
        <div class="transfer-modal-text">
          <h3>Success</h3>
          <p>The Kryptomon #{{kryptomon.tokenId}} has been successfully transfered.</p>
        </div>
        <div class="transfer-modal-buttons">
          <div class="button-outline" (click)="closeTransferProcedure()">
            Close
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="sale-modal-overlay" *ngIf="showSaleModal">
    <div class="sale-modal">
      <div class="sale-listing-init" *ngIf="!showConfirmationListing && !isSuccess">
        <div class="sale-card">
          <div class="sale-card-img">
            <img src="{{kryptomon.image}}" />
          </div>
          <div class="sale-card-content">
            <span>{{kryptomon.name}}</span>
            <div class="sale-card-rating">
              <div class="Stars" style="--rating: {{kryptomon.tierNumber}}"></div>
              {{kryptomon.tierName}}
            </div>
            <span>Speciality: {{kryptomon.speciality}}</span>
            <div class="sale-card-icons">
              <div class="sale-card-element">
                <img src="{{kryptomon.mainFamilyImage}}" />
              </div>
              <div class="sale-card-element">
                <img src="{{kryptomon.secondaryFamilyImage}}" />
              </div>
              <div class="sale-card-breed" *ngIf="kryptomon.breedingTotal">
                <img src="./assets/img/Icon/Heart.png" />
                {{kryptomon.breedingDone}}/{{kryptomon.breedingTotal}}
              </div>
              <div class="sale-card-sex">
                <img src="{{kryptomon.genderIcon}}" />
              </div>
              <div class="sale-card-gen">
                GEN: {{kryptomon.genes.generation}}
              </div>
            </div>
          </div>
        </div>
        <div class="sale-details-input">
          <div class="sale-input-titles">
            <h3>LIST FOR SALE</h3>
            <p class="text-gray">Set price and expiration date for {{kryptomon.name}}</p>
            <div class="prices">
              <span *ngIf="listingPrice>0">{{listingPrice.toLocaleString()}}$</span>
              <span *ngIf="listingPrice==undefined || listingPrice==''">0$</span>
              <span><img src="./assets/img/Icon/kmon-logo-micro.png">{{kmonPrice}}</span>
            </div>
          </div>
          <div class="sale-input-fields">
            <div class="sale-input-field">
              <p>Price</p>
              <div class="input-price">
                <span>$</span>
                <input type="number" [(ngModel)]="listingPrice" placeholder="2,000" (ngModelChange)="updateKMONPrice()">
              </div>
            </div>
            <div class="sale-input-field">
              <p>Expiration Date</p>
              <input type="date" [ngModel]="expirationDate | date:'dd/mm/yy'" placeholder="dd/mm/yyyy"
                (ngModelChange)="checkDateValidity($event)">
            </div>
          </div>
          <div class="sale-modal-buttons">
            <div class="button-outline" (click)="showSaleModal=false">
              Cancel
            </div>
            <div class="button-gradient" (click)="showConfirmationListing=true"
              *ngIf="listingPrice>0 && expirationDateUnix>0">
              List for sale
            </div>
            <div class="button-gradient disabled"
              *ngIf="listingPrice==undefined || listingPrice=='' || expirationDateUnix==0 || listingPrice<=0">
              List for sale
            </div>
          </div>
        </div>
      </div>
      <div class="sale-listing-confirm" *ngIf="showConfirmationListing && !isSuccess">
        <div class="sale-modal-text">
          <h3>Please confirm</h3>
          <p>You are about to list {{kryptomon.name}} on sale for {{listingPrice.toLocaleString()}}$</p>
          <p>Please re-enter the price to confirm.</p>
        </div>
        <div class="sale-modal-input">
          <p>Price</p>
          <div class="input-price">
            <span>$</span>
            <input type="number" [(ngModel)]="confirmPrice" placeholder="2,000" min="0">
          </div>
        </div>
        <div class="sale-modal-buttons">
          <div class="button-outline" (click)="showConfirmationListing=false" *ngIf="!isLoading">
            Cancel
          </div>
          <div class="button-gradient" *ngIf="(confirmPrice==listingPrice) && !isLoading"
            (click)="initiateSaleListing()">
            Proceed
          </div>
          <div class="button-gradient disabled" *ngIf="confirmPrice!==listingPrice">
            Proceed
          </div>
          <div class="button-gradient" *ngIf="isLoading">
            <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
          </div>
        </div>
      </div>
      <div class="sale-listing-success" *ngIf="isSuccess">
        <img src="{{kryptomon.image}}" />
        <h3>Your Kryptomon {{kryptomon.name}} has been listed for sale</h3>
        <div class="sale-modal-buttons">
          <div class="button-outline" (click)="closeListingProcedure()">
            Close
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="breed-modal-overlay" *ngIf="showBreedModal">
    <div class="breed-modal">
      <div class="breed-modal-setting" *ngIf="!isSuccess">
        <div class="breed-modal-text">
          <h3>Add to Breeding Center</h3>
          <p>You are about to add {{kryptomon.name}} to the breeding center.</p>
          <p>Please enter the price of how much you want to get paid.</p>
        </div>
        <div class="breed-modal-input">
          <p>Price</p>
          <div class="input-price">
            <span><img src="./assets/img/Icon/kmon-logo-micro.png"></span>
            <input type="number" [(ngModel)]="breedingPrice" placeholder="2,000">
          </div>
        </div>
        <div class="breed-modal-buttons">
          <div class="button-gradient" *ngIf="breedingPrice>0 && !isLoading" (click)="initiateBreedListing()">
            Proceed
          </div>
          <div class="button-gradient disabled" *ngIf="breedingPrice==0 || !breedingPrice">
            Proceed
          </div>
          <div class="button-gradient" *ngIf="isLoading">
            <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
          </div>
          <div class="button-outline" (click)="showBreedModal=false" *ngIf="!isLoading">
            Cancel
          </div>
        </div>
      </div>
      <div class="breed-modal-success" *ngIf="isSuccess">
        <img src="{{kryptomon.image}}" />
        <h3>Your Kryptomon {{kryptomon.name}} has been added to the Breeding Center.</h3>
        <div class="breed-modal-buttons">
          <div class="button-outline" (click)="closeBreedListingProcedure()">
            Close
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="sale-modal-overlay" *ngIf="showBidModal">
    <div class="sale-modal">
      <div class="sale-listing-init" *ngIf="!showConfirmationBidding && !isSuccess">
        <div class="sale-card">
          <div class="sale-card-img">
            <img src="{{kryptomon.image}}" />
          </div>
          <div class="sale-card-content">
            <span>{{kryptomon.name}}</span>
            <div class="sale-card-rating">
              <div class="Stars" style="--rating: {{kryptomon.tierNumber}}"></div>
              {{kryptomon.tierName}}
            </div>
            <span>Speciality: {{kryptomon.speciality}}</span>
            <div class="sale-card-icons">
              <div class="sale-card-element">
                <img src="{{kryptomon.mainFamilyImage}}" />
              </div>
              <div class="sale-card-element">
                <img src="{{kryptomon.secondaryFamilyImage}}" />
              </div>
              <div class="sale-card-breed" *ngIf="kryptomon.breedingTotal">
                <img src="./assets/img/Icon/Heart.png" />
                {{kryptomon.breedingDone}}/{{kryptomon.breedingTotal}}
              </div>
              <div class="sale-card-sex">
                <img src="{{kryptomon.genderIcon}}" />
              </div>
              <div class="sale-card-gen">
                GEN: {{kryptomon.genes.generation}}
              </div>
            </div>
          </div>
        </div>
        <div class="sale-details-input">
          <div class="sale-input-titles">
            <h3>MAKE A BID</h3>
            <p class="text-gray">Set bid price and expiration date for {{kryptomon.name}}</p>
            <div class="prices" *ngIf="kryptomon.order">
              <span>{{kryptomon.order.priceUSD.toLocaleString()}}$</span>
              <span> <img src="./assets/img/Icon/Cur-BNB.png"
                  *ngIf="kryptomon.order.paymentToken=='0x0000000000000000000000000000000000000000'">
                <img src="./assets/img/Icon/Cur-Kmon.png"
                  *ngIf="kryptomon.order.paymentToken!=='0x0000000000000000000000000000000000000000'">{{kryptomon.order.tokenPaymentAmount.toLocaleString()}}</span>
            </div>
          </div>
          <div class="sale-input-fields">
            <div class="sale-input-field">
              <p>Bid Amount</p>
              <div class="input-price">
                <img class="small-currency-icon" src="./assets/img/Icon/Cur-Kmon.png" />
                <input type="number" [(ngModel)]="bidAmount" placeholder="2,000">
              </div>
            </div>
            <div class="sale-input-field">
              <p>Expiration Date (Less than 6 months)</p>
              <input type="date" [ngModel]="expirationDate | date:'dd/mm/yy'" placeholder="dd/mm/yyyy"
                (ngModelChange)="checkDateValidityBid($event)">
            </div>
          </div>
          <div class="sale-modal-buttons">
            <div class="button-gradient" (click)="showConfirmationBidding=true"
              *ngIf="bidAmount>0 && expirationDateUnix>0">
              Send Bid
            </div>
            <div class="button-gradient disabled"
              *ngIf="bidAmount==undefined || bidAmount=='' || expirationDateUnix==0 || bidAmount<=0">
              Send Bid
            </div>
            <div class="button-outline" (click)="showBidModal=false">
              Cancel
            </div>
          </div>
        </div>
      </div>
      <div class="sale-listing-confirm" *ngIf="showConfirmationBidding && !isSuccess">
        <div class="sale-modal-text">
          <h3>Please confirm</h3>
          <p>You are about to bid {{bidAmount.toLocaleString()}}KMON for {{kryptomon.name}}</p>
          <p>Please re-enter the bid amount to confirm.</p>
        </div>
        <div class="sale-modal-input">
          <p>Bid Amount</p>
          <div class="input-price">
            <img class="small-currency-icon" src="./assets/img/Icon/Cur-Kmon.png" />
            <input type="number" [(ngModel)]="confirmPrice" placeholder="2,000" min="0">
          </div>
        </div>
        <div class="sale-modal-buttons">
          <div class="button-gradient" *ngIf="confirmPrice>0 && confirmPrice==bidAmount && !isLoading"
            (click)="initiateBidOffer()">
            Proceed
          </div>
          <div class="button-gradient disabled"
            *ngIf="confirmPrice<=0 || confirmPrice==undefined || confirmPrice==null || confirmPrice!==bidAmount">
            Proceed
          </div>
          <div class="button-gradient" *ngIf="isLoading">
            <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
          </div>
          <div class="button-outline" (click)="showConfirmationBidding=false" *ngIf="!isLoading">
            Cancel
          </div>
        </div>
      </div>
      <div class="sale-listing-success" *ngIf="isSuccess">
        <img src="{{kryptomon.image}}" />
        <h3>Your Bid for Kryptomon {{kryptomon.name}} has been sent</h3>
        <div class="sale-modal-buttons">
          <div class="button-outline" (click)="closeBiddingProcedure()">
            Close
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="sale-modal-overlay" *ngIf="showBuyModal">
    <div class="sale-modal">
      <div class="sale-listing-init" *ngIf="!isSuccess">
        <div class="sale-card">
          <div class="sale-card-img">
            <img src="{{kryptomon.image}}" />
          </div>
          <div class="sale-card-content">
            <span>{{kryptomon.name}}</span>
            <div class="sale-card-rating">
              <div class="Stars" style="--rating: {{kryptomon.tierNumber}}"></div>
              {{kryptomon.tierName}}
            </div>
            <span>Speciality: {{kryptomon.speciality}}</span>
            <div class="sale-card-icons">
              <div class="sale-card-element">
                <img src="{{kryptomon.mainFamilyImage}}" />
              </div>
              <div class="sale-card-element">
                <img src="{{kryptomon.secondaryFamilyImage}}" />
              </div>
              <div class="sale-card-breed" *ngIf="kryptomon.breedingTotal">
                <img src="./assets/img/Icon/Heart.png" />
                {{kryptomon.breedingDone}}/{{kryptomon.breedingTotal}}
              </div>
              <div class="sale-card-sex">
                <img src="{{kryptomon.genderIcon}}" />
              </div>
              <div class="sale-card-gen">
                GEN: {{kryptomon.genes.generation}}
              </div>
            </div>
          </div>
        </div>
        <div class="sale-details-input">
          <div class="sale-input-titles">
            <h3>PURCHASE</h3>
            <p class="text-gray">You are about to buy the Kryptomon {{kryptomon.name}}</p>
            <div class="prices" *ngIf="kryptomon.order">
              <span>{{kryptomon.order.priceUSD.toLocaleString()}}$</span>
              <span> <img src="./assets/img/Icon/Cur-BNB.png"
                  *ngIf="kryptomon.order.paymentToken=='0x0000000000000000000000000000000000000000'">
                <img src="./assets/img/Icon/Cur-Kmon.png"
                  *ngIf="kryptomon.order.paymentToken!=='0x0000000000000000000000000000000000000000'">{{kryptomon.order.tokenPaymentAmount.toLocaleString()}}</span>
            </div>
          </div>
          <div class="sale-modal-buttons">
            <div class="button-gradient" (click)="initiatePurchase()" *ngIf="!isLoading">
              Purchase
            </div>
            <div class="button-gradient" *ngIf="isLoading">
              <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
            </div>
            <div class="button-outline" (click)="showBuyModal=false">
              Cancel
            </div>
          </div>
          <div class="is-longer-msg" *ngIf="isLonger">
            <p>Some times purchased funds with the Credit Card can take longer than expected to arrive, leave this
              window open.</p>
          </div>
        </div>
      </div>
      <div class="sale-listing-success" *ngIf="isSuccess">
        <img src="{{kryptomon.image}}" />
        <h3>Congratulation {{kryptomon.name}} is now your!</h3>
        <div class="sale-modal-buttons">
          <div class="button-outline" (click)="closeBuyingProcedure()">
            Close
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="simplexWidget" [ngClass]="{'hide': !showWidget}" *ngIf="!waitingForFunds">
    <form id="simplex-form">
      <div id="checkout-element"> -->
  <!-- checkout will be rendered here -->
  <!-- </div>
    </form>
    <div class="buttons">
      <div class="button-outline" (click)="closeSimplex()">Cancel</div>
    </div>
  </div> -->
  <div class="overlay" *ngIf="showOnramper" (click)="closeOnramper()">
    <iframe style="border-radius: 4px; border: 1px solid #58585f; margin: auto;max-width: 420px" [src]="srcOnramper"
      height="630px" width="420px" title="Onramper widget" allow="accelerometer; autoplay; camera; gyroscope; payment"
      class="iframe-onramper">
    </iframe>
  </div>
</div>